import React, { FC, useState } from 'react';

import AccountTypeRadioOption from './AccountTypeRadioOption';
import CapabilityList from './CapabilityList';
import { RadioGroupOption } from './acl-types';
import { getAccountTypeOptions } from './acl-util';
import { Permission, ServiceAccount } from '../../../api/gql/graphql';

// @tecton
import { FlexItem, Callout, FlexGroupWrapper } from '@tecton/ComponentRedesign';

interface ModifyAccountTypeProps {
  serviceAccount?: ServiceAccount;
  selectedAccountType?: string;
  roleDescriptionMap: Record<string, Permission[]>;
  onSelectionClicked: (selectedAccountType: string /** undefined means the selection didn't change */) => void;
}

const ModifyServiceAccountAccountType: FC<ModifyAccountTypeProps> = ({
  serviceAccount,
  selectedAccountType,
  roleDescriptionMap,
  onSelectionClicked,
}) => {
  const accountType = selectedAccountType ?? serviceAccount?.accountType ?? 'Regular';
  const options = getAccountTypeOptions(accountType);
  const [accountTypeOptions, setAccountTypeOptions] = useState<RadioGroupOption[]>(options);
  const [roleDescription, setRoleDescription] = useState<Permission[]>(roleDescriptionMap[accountType]);

  return (
    <>
      <FlexGroupWrapper gap="xl" direction="column">
        <FlexItem>
          <FlexGroupWrapper gap="xl" direction="row">
            <FlexItem grow={4}>
              <AccountTypeRadioOption
                options={accountTypeOptions}
                onSelection={(selectedOption) => {
                  const options = getAccountTypeOptions(selectedOption.id);
                  setAccountTypeOptions(options);
                  setRoleDescription(roleDescriptionMap[selectedOption.id]);
                  onSelectionClicked(selectedOption?.id);
                }}
              />
            </FlexItem>
            <FlexItem grow={5}>
              <CapabilityList roleDescriptions={roleDescription} />
            </FlexItem>
          </FlexGroupWrapper>
        </FlexItem>
        <FlexItem>
          <Callout mode="neutral" title={'Note'}>
            {serviceAccount?.name} also inherits Admin privileges from groups. This modal only modifies their directly
            assigned account type
          </Callout>
        </FlexItem>
      </FlexGroupWrapper>
    </>
  );
};

export default ModifyServiceAccountAccountType;
